var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlcohol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369 431 c-59 -37 -80 -46 -93 -39 -41 23 -87 -13 -101 -79 -7 -36 -14 -33 74 -35 38 -1 61 21 61 58 0 17 18 34 75 69 41 26 75 53 75 61 0 21 -9 18 -91 -35z m-95 -83 c14 -22 -12 -52 -37 -42 -17 6 -23 44 -10 58 11 11 35 3 47 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 387 c0 -7 45 -57 100 -112 l100 -100 0 -62 c0 -49 3 -63 15 -63 12 0 15 14 15 63 l0 62 104 104 c58 58 103 108 100 113 -3 4 -19 8 -35 8 -24 0 -30 -4 -27 -20 2 -13 -21 -43 -72 -95 -41 -41 -79 -75 -85 -75 -6 0 -46 36 -89 79 l-79 80 53 3 c31 2 55 8 58 16 3 9 -17 12 -77 12 -59 0 -81 -3 -81 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 15 c0 -12 18 -15 105 -15 87 0 105 3 105 15 0 12 -18 15 -105 15 -87 0 -105 -3 -105 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcohol);
export default __webpack_public_path__ + "static/media/alcohol.0caf3b5d91298133271d25acec1f25b0.svg";
export { ForwardRef as ReactComponent };